import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import translations from "../assets/locals/translations";
import {
  addassigneAreaToDb,
  clearAddassigneAreaState,
} from "../redux/slices/assignedAreaSlice";
import {
  setEdiassignareaData,
  clearEditassignareaData,
  clearEditassignareaState,
  editassignareaUpdateToDb,
} from "../redux/slices/editassignareaSlice";

import AlertDeleteModal from "./AlertDelete/AlertDeleteModal";

import Axios from "axios";
import { getToPathname } from "@remix-run/router";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllVillageAction } from "./Master/Village/getEditeVillage";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";

export default function AddAssignArea() {
  const location = useLocation();
  const areaAssign = location.state ? location.state.assigneAreaPerUser : [];
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];

  console.log(areaAssign, "areaAssign");
  const [selectedCategoryList, setSelectedCategoryList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [allVillageData, setAllVillageData] = useState([]);
  const [selectedOptionVillage, setSelectedOptionVillage] = useState([]);
  const [selectedVillagesList, setSelectedVillagesList] = useState([]);
  const [selectedVillages, setSelectedVillages] = useState([]);
  const [selectedCtaegory, setSelectedCtaegory] = useState([]);
  const [selectedDistributionType, setSelectedDistributionType] = useState([]);
  const [enquireCtaegory, setEnquiryCtaegory] = useState([]);
  const [show, setShow] = useState(0);
  const [allUser, setallUser] = useState([]);
  const [selectedId, setSelectedId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [categoryd, setCategoryd] = useState(null);
  const [dId, setDId] = useState(null);

  const addAssignState = useSelector(
    (state) => state.addassigneAreaSlice.addassigneAreaState
  );
  const editassignareaData = useSelector(
    (state) => state.editassignareaDataState.editassignareaSliceState
  );

  function clearInpHook() {
    setSelectedCtaegory([]);
    setSelectedOptionVillage([]);
  }

  useEffect(() => {
    if (addAssignState.isSuccess) {
      if (addAssignState.message.isSuccess) {
        console.log(addAssignState, "addAssignState");
        dispatch(setShowMessage(t.assignareadeleted || "Area is assigned"));
        dispatch(clearAddassigneAreaState());
        setShow(0);
        navigate("/administration/employees");
        clearInpHook();
        //  clearaddaddAgency();
      } else {
        dispatch(setShowMessage("Something is wrong"));
      }
    }
  }, [addAssignState]);
  const redirectModal = () => {
    navigate(-1);
  };

  useEffect(() => {
    if (editassignareaData.isSuccess) {
      if (editassignareaData.message.isSuccess) {
        console.log(editassignareaData, "editassignareaData");
        dispatch(setShowMessage(t.assignareadeleted || "Assign Area is updated"));
        dispatch(clearEditassignareaState());
        setShow(0);
        navigate("/administration/employees");
        // navigate("/sale/area-Assign")
        clearInpHook();
        //  clearaddaddAgency();
      } else {
        dispatch(setShowMessage("Something is wrong"));
      }
    }
  }, [editassignareaData]);

  async function getAllUserFromDb() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/areaAssign/get-allUser`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setallUser(response.data.result);
      }
    });
  }

  useEffect(() => {
    getAllUserFromDb();
    console.log(allUser, "alluser");
  }, []);

  useEffect(() => {
    getAllVillageAction()
      .then((data) => {
        setAllVillageData(data.result);
      })
      .catch((error) => {
        console.error("Error in getAllVillageAction:", error);
      });
    getEnquiryCategoryFromDb();
  }, []);
  const handleChangeCategory = (selectedOption) => {
    console.log("selectedOption", selectedOption);
    setSelectedCtaegory(selectedOption);
  };

  const categoryoptions = enquireCtaegory.map((category) => ({
    value: category.id,
    label: category.category_name,
  }));
  const options = allVillageData.map((village) => ({
    value: village.id,
    label: village.name,
  }));
  const handleShow = () => {
    setShow(1);
    setSelectedId(areaAssign[0].userId);
  };

  const handleClose = () => {
    setShow(0);
  };

  const handleChangeVillage = (selectedOption) => {
    setSelectedOptionVillage(selectedOption);
  };

  function handleSubmit() {
    console.log(selectedId, "selectedId");
    console.log(selectedOptionVillage, "selectedOptionVillage");
    console.log(selectedCtaegory, "selectedCtaegory");
    console.log(allUser, "allUser");
    let userAr = [];
    let villageAr = [];
    let categoryAr = [];

    if (selectedCtaegory.length > 0) {
      selectedOptionVillage.map((singleVillage) => {
        villageAr.push({ value: singleVillage.value });
      });
      selectedCtaegory.map((singleCategory) => {
        categoryAr.push({
          category: singleCategory.value,
          value: villageAr,
        });
      });
    }
    userAr.push({ userId: userId, id: selectedId, category: categoryAr });

    if (show === 2) {
      console.log("userAr", userAr);
      dispatch(editassignareaUpdateToDb(userAr));
    } else {
      console.log("userArrr", userAr);
      dispatch(addassigneAreaToDb(userAr));
    }
  }

  const editActionCall = (data) => {
    setShow(2);
    dispatch(setEdiassignareaData(data));
    console.log("data", data);
    console.log("data.id", data.id);
    console.log("data.id", data.id);
    setSelectedId(data.categoryData.value);
    setUserId(data.userId);
    let newArr = [];
    console.log(data.villageData, "JEUEUUUEU");
    if (data.villageData && data.villageData.length > 0) {
      newArr = data.villageData;
      newArr = data.villageData;
    }


    console.log(newArr, "newArr");
    setSelectedOptionVillage(newArr);

    const newArry = data.categoryData;
    console.log(data.categoryData, "catoegiru Dtaa");


    console.log(newArry, "newArry");
    setSelectedCtaegory([newArry]);
  };

  const deleteActionCall = (data) => {
    console.log(data, "cccccccccccccccccccccccc")
    setType("asignArea_delete");
    setId(data.userId);
    setCategoryd(data.categoryData.value);
    // setDId(data.villageData);
    setDeleteMessage(
      `${t.areyousuredeleteassignarea || "Are You Sure"}  '${data.categoryData.label}'?`
    );
    setDisplayConfirmationModal(true);
  };
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const submitDelete = async () => {
    if (id, categoryd) {
      const url = `${process.env.REACT_APP_NODE_URL}/api/areaAssign/delete-area/${id}/${categoryd}`;
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      await Axios.get(url, config).then((response) => {
        if (response.data && response.data.result === "success") {
          hideConfirmationModal();
          navigate("/administration/employees");
        }
      });
    }
  };

  function handlCancel() {
    console.log(selectedOptionVillage, "selectedOptionVillage");
    navigate("/administration/employees");
  }
  async function getEnquiryCategoryFromDb() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-enquiry-categories`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data?.isSuccess) {
        setEnquiryCtaegory(response.data.result);
      }
    });
  }

  useEffect(() => {
    if (show === 0) {
      setSelectedCtaegory([]);
      setSelectedOptionVillage([]);
    }
  }, [show]);

  return (
    <>
      <div className="addUser myBorder bg-white rounded p-3">
        <main>

          <div className="row">
            <div className="col-md-6">
              <h3 className="myLabel">{t.assignarea || "Assign Area"}</h3>
            </div>
            <div className="col-md-6 d-flex justify-content-end align-items-end">
              <Button
                variant="btn btn-warning mx-1"
                style={{ width: '70px', height: '35px', fontSize: '14px', borderRadius: '20px' }}
                onClick={() => {
                  redirectModal();
                }}
              >
                {t.back || "BACK"}
              </Button>
            </div>
          </div>
          <div className="row mt-2">
            <h5 className="myLabel">{t.userinfo || "User Information"}</h5>
          </div>

          <div className=" row mt-2 ">
            <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
              <label className="myLabel">{t.name || "Name"} </label>{" "}
              {areaAssign && (
                <>
                  <p className="myInput inputElement">
                    {areaAssign[0].fname} {areaAssign[0].lname}
                    { }
                  </p>
                </>
              )}
            </section>

            <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
              <label className="myLabel">{t.phoneno || "Phone Number"} </label>
              {areaAssign && (
                <>
                  <p className="myInput inputElement">
                    {areaAssign[0].phonenumber}
                  </p>
                </>
              )}
            </section>
            <section className="d-flex justify-content-end  align-items-start  mt-3 flex-column col-12 col-sm-6 col-lg-4">
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleShow}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-plus-circle"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                </svg>
                &nbsp; {t.addassignarea || "Assign Area"}
              </button>
            </section>
          </div>

          <div className="row mt-5 m-0">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">{t.category || "Category"} {t.enquiry || "Enquiry"}</th>
                  <th scope="col">{t.distributiontype || "Distribution Type"}</th>
                  <th scope="col">{t.village || "Villages"}</th>
                  <th scope="col">{t.action || "Action"}</th>
                </tr>
              </thead>
              <tbody>
                {areaAssign.map((item, index) => (
                  <tr key={index}>
                    <th scope="row">{index + 1}</th>
                    <td>
                      <ul>
                        <li>{item.categoryData.label}</li>
                      </ul>
                    </td>
                    <td>
                      <ul>
                        <li>{item.distributiontype}</li>
                      </ul>
                    </td>
                    <td>
                      <Select
                        isDisabled={true}
                        defaultValue={() => {
                          const villages = item.villageData.map((village) => ({
                            label: village.label,
                          }));
                          return villages;
                        }}
                        isSearchable={true}
                        isMulti
                        placeholder="Search for a village..."
                      />
                    </td>
                    <td>
                      <button
                        onClick={() => {
                          editActionCall(item);
                        }}
                        className="myActionBtn m-1"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          className="bi bi-pencil-square"
                          viewBox="0 0 16 16"
                        >
                          <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                          <path
                            fillRule="evenodd"
                            d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => {
                          deleteActionCall(item);
                        }}
                        className="myActionBtn m-1"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="currentColor"
                          className="bi bi-trash3"
                          viewBox="0 0 16 16"
                        >
                          <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* =========table======= */}

          <div className="row mt-3 m-0">
            <button
              className="col-12 col-sm-5 col-lg-2 myBtn py-2"
              onClick={handleSubmit}
              type="button"
            >
              {t.save || "Save"}
            </button>
            <button
              className="ms-0 ms-sm-3 mt-3 mt-sm-0 col-12 col-sm-5 col-lg-2 myBtn py-2"
              onClick={handlCancel}
              type="button"
            >
              {t.cancel || "Cancel"}
            </button>
          </div>
        </main>
      </div>
      {/* new modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title" id="TalukaModalLabel">
            {show === 1 ? t.addassignarea || "Add Assign Area" : t.editassignarea || "Edit Assign Area"}
          </h5>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <div className="row mt-5">
              <h5>{t.selectcategory || "Select Category"}</h5>
              <Select
                value={selectedCtaegory}
                onChange={handleChangeCategory}
                options={categoryoptions}
                isSearchable={true}
                isMulti
                // isMulti={show === 1 ? true : false}
                placeholder={t.searchforacategory || "Search for a category..."}
              />

              <h5 className="mt-4">{t.selectvillageswanttoassign || "Select Villages want to assign"}</h5>
              <Select
                value={selectedOptionVillage}
                onChange={handleChangeVillage}
                options={options}
                isSearchable={true}
                isMulti
                placeholder={t.searchforavillage || "Search for a village..."}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t.close || "Close"}
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {t.save || "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      <AlertDeleteModal
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={id}
        categoryd={categoryd}
        message={deleteMessage}
      />
    </>
  );
}
